export const filter = {
    id: "",
    name: "",
    phone_number: "",
    partner_clinic_id: "",
    search: "",
    created_at: "",
    updated_at: "",
};
